import React from 'react';
import { Link } from 'react-router-dom';
import { clsx } from 'clsx';
import { Col, Row } from 'antd';

import { CxCredit } from '@types';
import { dateFormatter } from '@utils';
import { InitialCard } from '@components';
import { UserContacts } from '@pages/user/UserInitial/user-contacts';
import cls from './MainInfo.module.css';

interface Props {
  cxCredit: CxCredit;
}

export const MainInfo = ({ cxCredit }: Props) => {
  return (
    <InitialCard mb={12}>
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={3}>
          <div className={cls.col}>
            <Link className={cls.link} to={`/credit/${cxCredit.id}?initial`}>{cxCredit.code}</Link>
          </div>
        </Col>
        <Col xs={24} sm={13}>
          <div className={clsx(cls.col, cls.name)}>
            <Link className={cls.link} to={`/user/${cxCredit.userId}?initial`}>
              {cxCredit.user.fullName}
            </Link>
            {cxCredit.accredited === 'company' && (
              <>
                <span>/</span>
                <Link className={cls.link} to={`/user/${cxCredit.userId}?initial`}>
                  {cxCredit.accreditedName}
                </Link>
              </>
            )}
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <div className={clsx(cls.row, cls.rowLast)}>
            <div className={cls.col}>
              Payment Date:<br/>
              {cxCredit.paymentAt ? dateFormatter.toDateSlash(cxCredit.paymentAt) : '---'}
            </div>
            <div className={cls.col}>
              <UserContacts user={cxCredit.user} showTooltip className={cls.userContacts} />
            </div>
          </div>
        </Col>
      </Row>
    </InitialCard>
  );
};
